<template>
  <div>
    <div class="vx-row">
      <!-- MULTIPLE COLUMNS-->
      <div class="vx-col lg:w-4/4 w-full relative">
        <vx-card title="">
          <div class="demo-alignment">
            <v-select
              v-model="selectedDepo"
              :options="depoListesi"
              @input="ps"
            ></v-select>
            <vs-input
              class="inputx"
              placeholder="Ürün Kodu"
              @keyup.enter="barkodOku()"
              autocomplete="off"
              :disabled="Bvalidated == 0"
              :ref="barkod"
              id="barkodM"
              v-model="barkod"
              style="width: 120px"
            />
            <vs-input
              class="inputx"
              placeholder="Adet"
              id="barkodM"
              @keyup.enter="barkodOku()"
              :ref="barkodAdet"
              v-model="barkodAdet"
              style="width: 120px"
            />
            <vs-button
              @click="stokListeAc()"
              type="gradient"
              style="border-radius: 5px"
              v-if="!isMobile()"
              >Stok Listesi</vs-button
            >
            <vs-button
              @click="tumListe()"
              style="border-radius: 5px"
              color="danger"
              type="gradient"
              >Tümü</vs-button
            >
            <!--
            <vs-button
              @click="openAlert('warning')"
              style="border-radius: 5px"
              color="success"
              type="gradient"
              id="button-with-loading-toplusil"
              class="vs-con-loading__container"
              >Toplu Sil</vs-button
            >-->
          </div>
        </vx-card>

        <vx-card title="" style="margin-top: 10px">
          <vs-table :data="sipariseGoreUrunListesi">
            <template slot="thead">
              <vs-th sort-key="stokkodu">Stok Kodu</vs-th>
              <vs-th sort-key="stokkodu">Barkod</vs-th>

              <vs-th>Adet</vs-th>

              <vs-th>Çıkar</vs-th>
              <vs-th>Sil</vs-th>
              <vs-th>Stok Adı</vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr state="" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td :data="data[indextr].merchantSku">
                  {{ data[indextr].STOK_KODU }}
                </vs-td>
                <vs-td :data="data[indextr].merchantSku">
                  {{ data[indextr].barkod }}
                </vs-td>

                <vs-td :data="data[indextr].stokAdi">
                  <span style="font-size: 18px">{{ data[indextr].adet }}</span>
                </vs-td>
                <vs-td :data="data[indextr].stokAdi">
                  <feather-icon
                    icon="FolderMinusIcon"
                    class="cursor-pointer"
                    svgClasses="w-8 h-8"
                    @click="
                      listedenCikar1(data[indextr].id, data[indextr].barkod)
                    "
                  />
                </vs-td>

                <vs-td :data="data[indextr].stokAdi">
                  <feather-icon
                    icon="TrashIcon"
                    class="cursor-pointer"
                    svgClasses="w-8 h-8"
                    style="color: red"
                    @click="listedenCikar(data[indextr].id)"
                  />
                </vs-td>
                <vs-td :data="data[indextr].stokAdi">
                  {{ data[indextr].STOK_ADI }}
                </vs-td>
              </vs-tr>

              <vs-tr>
                <vs-td> </vs-td>
                <vs-td> </vs-td>
                <vs-td> </vs-td>
                <vs-td> </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </vx-card>
      </div>
    </div>
    <vs-popup class="holamundo" title="Stok Sayım" :active.sync="popupOnayla">
      <template>
        <b-row>
          <b-col lg="4" style="padding-top: 10px"> Adet giriniz </b-col>
          <b-col lg="8">
            <vs-input
              @focus="$event.target.select()"
              class="inputx"
              placeholder="Adet"
              id="secAdet"
              value="0"
              v-model="gelenEvent"
            />
          </b-col>
        </b-row>
        <b-row style="margin-top: 25px; text-align: center">
          <h4>Girilen adeti onaylıyor musunuz?</h4>
        </b-row>
        <b-row style="margin-top: 25px">
          <b-col lg="6"> </b-col>
          <b-col lg="3">
            <vs-button @click="onayla()" color="success" type="filled"
              >Onayla</vs-button
            >
          </b-col>
          <b-col lg="3">
            <vs-button @click="popupKapat()" color="danger" type="filled"
              >Vazgeç</vs-button
            >
          </b-col>
        </b-row>
      </template>
    </vs-popup>
    <vs-popup
      fullscreen
      class="holamundo"
      title="Stok Listesi"
      :active.sync="popupStokListesi"
    >
      <vs-input
        class="inputx"
        placeholder="Barkod"
        @keyup.enter="stokSayimListesi()"
        :ref="barkodListe"
        v-model="barkodListe"
      />
      <vs-table :data="dataStokListesi">
        <template slot="thead">
          <vs-th sort-key="stokKodu">Stok Kodu</vs-th>
          <vs-th sort-key="Barkod">Barkod</vs-th>
          <vs-th sort-key="StokAdi">Stok Adı</vs-th>
          <vs-th sort-key="adet">Depo Adet</vs-th>
          <vs-th sort-key="toplam"> </vs-th>

          <vs-th></vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].stokKodu">
              {{ data[indextr].stokKodu }}
            </vs-td>
            <vs-td :data="data[indextr].Barkod">
              {{ data[indextr].Barkod }}
            </vs-td>
            <vs-td :data="data[indextr].StokAdi">
              {{ data[indextr].StokAdi }}
            </vs-td>
            <vs-td :data="data[indextr].stokAdet">
              {{ data[indextr].stokAdet }}
            </vs-td>
            <vs-button
              @click="sayimAdetEkle(data[indextr].stokKodu)"
              color="success"
              type="filled"
              >Adet Ekle</vs-button
            >

            <vs-td> </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vs-popup>
  </div>
</template>

   


<script>
import vSelect from "vue-select";
import state from "../../store/state";
import store from "../../store/store";
import Store from "../../store/store";
import { isMobile } from "mobile-device-detect";

export default {
  components: {
    "v-select": vSelect,
  },
  data() {
    return {
      backgroundLoading: "success",
      colorLoading: "#fff",
      gelenEvent: "",
      popupOnayla: false,
      options: [],
      optionsParti: [],
      pazaryeriTum: [],
      list: [],
      listSonFaturalar: [],
      listSiparis: [],
      sipariseGoreUrunListesi: [],
      progress: 0,
      activePrompt: false,
      popupStokListesi: false,
      dataStokListesi: [],
      pazaryeriVal: "",
      partiVal: "",
      toplamParca: 0,
      selected: { id: 0, label: "Cari" },
      selectedDepo: "",
      iadeModel: { id: 0, label: "İade red" },
      selectedParti: { id: 0, label: "Parti Nolar" },
      popupActive: false,
      popupFatura: false,
      popupActiveSiparis: false,
      popupActiveCikti: false,
      barkod: "",
      barkodAdet: "",
      cariKod: "",
      siparisBulOrderNumber: "",
      genelSiparisNo: "",
      ekleAdet: "",
      genelKargoAdi: "",
      genelKargoNo: "",
      genelMusteri: "",
      hediyeMi: 0,
      genelToplam: 0,
      eklenenDeger: "",
      indext: 0,
      indext1: 0,
      urunResim: "",
      validated: 1,
      Bvalidated: 1,
      validatedF: 1,
      siparisToplamParca: 0,
      eklenenToplamParca: 0,
      askiDurumu: false,
      aski: 0,
      imageLink: "",
      ciktiListesi: [],
      depoListesi: [],
      jsonD: "",
      dr: "",
      popupActiveFaturaCikti: false,
      receiptId: 0,
      faturaNo: "",
      ilkOkuma: 0,
      recId: 0,
      total: 0,
      faturaAranan: "",
      faturaBulOrderNumber: "",
      im: 0,
      iadeOrderNumber: "",
      iadeLineItemId: "",
      stokKodu: "",
    };
  },
  methods: {
    openAlert(color) {
      this.$vs.dialog({
        color: color,
        title: "Uyarı", //`Dialog - ${this.colorAlert}`,
        text: "Listenin tümü silinecek. Emin misiniz?",
        acceptText: "Sil",
        accept: this.topluSil,
      });
    },
    topluSil() {
      var vm = this;
      var vs = this.$vs;

      if (vm.selectedDepo == "") {
        vs.notify({
          title: "Uyarı",
          text: "Depo Kodu seçiniz.",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center",
        });
      } else {
        
        const soap = require("soap");
        const url = state.sistemAddress;
        const args = {
          depoKodu: vm.selectedDepo,
        };

        soap.createClient(url, function (err, client) {
          client.hizliSatisTopluSil(args, function (err, result) {
            if (result.hizliSatisTopluSilResult == "-1") {
              Store.dispatch("logout");
              //this.$store.dispatch('login', payload)
            }
            vs.notify({
              title: "Başarılı",
              text: "Silme işlemi tamamlandı.",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "success",
              position: "top-center",
            });

          });
        });
      }
    },
    popupKapat() {
      this.popupOnayla = false;
    },
    onayla() {
      //alert(this.gelenEvent)
      this.Bvalidated = 0;
      const vm = this;
      const vs = this.$vs;

      if (this.gelenEvent == "") {
        vs.notify({
          title: "Adet Giriniz",
          text: "Lütfen Stok Adet Giriniz",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "success",
          position: "top-center",
        });
      } else {
        vm.sipariseGoreUrunListesi = "";
        const soap = require("soap");
        const url = state.sistemAddress;
        //console.log(this.pazaryeriVal.trim()+"**"+this.partiVal+"**"+vm.barkod+"**"+this.aski+"**"+gelenorder+"**"+Store.state.tokenId)
        //  alert(vm.barkod)

        const args = {
          stokKodu: this.stokKodu,
          adet: this.gelenEvent,
          depoKodu: this.selectedDepo,
          islemTipi: 1,
          kullaniciId: Store.state.UserId,
        };
        console.log(args);
        soap.createClient(url, function (err, client) {
          client.depoSayimEkle(args, function (err, result) {
            console.log(result);
            vm.veriler = JSON.parse(result.depoSayimEkleResult);

            vm.sipariseGoreUrunListesi = vm.veriler;
            //document.getElementById("barkodM").value="";
            vm.barkod = "";
            vm.barkodAdet = "";
            vm.Bvalidated = 1;
            vm.barkodListe = "";
            vm.gelenEvent = "";
            vm.popupOnayla = false;
            vm.focuslan();
          });
        });
      }
    },
    listedenCikar(id) {
      // alert(anaStokKodu)
      var vm = this;

      const soap = require("soap");
      const url = state.sistemAddress;
      const args = { id: id, cariKodu: "", depoKodu: this.selectedDepo };
      // console.log(args)
      soap.createClient(url, function (err, client) {
        client.hizliSatisSil(args, function () {
          vm.ps();
        });
      });
    },
    isMobile: function () {
      /*	var check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check;*/
      return isMobile;
    },
    stokListeAc() {
      const vm = this;
      const vs = this.$vs;
      if (vm.selectedDepo == null || vm.selectedDepo == "") {
        vs.notify({
          title: "Depo Seç",
          text: "Lütfen Depo Seçiniz.",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "red",
          position: "top-center",
        });
      } else {
        this.popupStokListesi = true;
      }
    },
    stokSayimListesi() {
      this.dataStokListesi = [];
      //this.dataStokListesi=null
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;

      const args = {
        token: Store.state.tokenId,
        kod: vm.barkodListe,
        pazaryeri: "",
        depoNo: this.selectedDepo,
      };
      soap.createClient(url, function (err, client) {
        client.stokSayim(args, function (err, result) {
          if (result.stokSayimResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }

          vm.veriler = JSON.parse(result.stokSayimResult);
          vm.dataStokListesi = vm.veriler;
        });
      });
    },
    sayimAdetEkle(stokKodu) {
      this.stokKodu = stokKodu;
      this.popupOnayla = true;
    },
    listedenCikar1(id, barkod) {
      // alert(anaStokKodu)
      this.barkodAdet = -1;
      this.barkod = barkod;
      this.barkodOku();
    },

    indexbul(array, conditionFn) {
      const item = array.find(conditionFn);
      return array.indexOf(item);
    },
    ps1(text) {
      this.partiVal = text;
    },
    ps() {
      //alert(this.selectedDepo)
      var vm = this;
      vm.sipariseGoreUrunListesi = null;
      vm.sipariseGoreUrunListesi = "";
      const soap = require("soap");
      const url = state.sistemAddress;
      //console.log(this.pazaryeriVal.trim()+"**"+this.partiVal+"**"+vm.barkod+"**"+this.aski+"**"+gelenorder+"**"+Store.state.tokenId)

      const args = {
        kullaniciId: store.state.UserId,
        depoKodu: this.selectedDepo,
        islemTipi: 1,
        listeTuru: 0,
      };
      soap.createClient(url, function (err, client) {
        client.acikHizliSiparisDepo(args, function (err, result) {
          vm.veriler = JSON.parse(result.acikHizliSiparisDepoResult);

          vm.sipariseGoreUrunListesi = vm.veriler;
        });
      });
    },
    depoListeleme() {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
      };
      soap.createClient(url, function (err, client) {
        client.depoList(args, function (err, result) {
          //  console.log(result.depoListResult)
          vm.veriler = JSON.parse(result.depoListResult);
          // console.log(vm.veriler.name)
          //   var parsed = Object.keys(vm.veriler);
          vm.veriler.forEach((val, ind) => {
            vm.depoListesi.push(val.name);
          });
          // console.log(vm.depoListesi)
          // vm.depoListesi = vm.veriler.name;
        });
      });
    },
    tumListe() {
      //alert(this.selectedDepo)
      var vm = this;
      vm.sipariseGoreUrunListesi = null;
      vm.sipariseGoreUrunListesi = "";
      const soap = require("soap");
      const url = state.sistemAddress;
      //console.log(this.pazaryeriVal.trim()+"**"+this.partiVal+"**"+vm.barkod+"**"+this.aski+"**"+gelenorder+"**"+Store.state.tokenId)

      const args = {
        kullaniciId: store.state.UserId,
        depoKodu: this.selectedDepo,
        islemTipi: 1,
        listeTuru: 1,
      };
      soap.createClient(url, function (err, client) {
        client.acikHizliSiparisDepo(args, function (err, result) {
          console.log(result.acikHizliSiparisDepoResult);
          vm.veriler = JSON.parse(result.acikHizliSiparisDepoResult);
          vm.sipariseGoreUrunListesi = vm.veriler;
        });
      });
    },
    siparisBul() {
      var vm = this;

      const soap = require("soap");
      const url = state.sistemAddress;
      // alert(this.pazaryeriVal)
      const args = {
        pazaryeri: "Trendyol",
        token: Store.state.tokenId,
        sayfa: 0,
        orderNumber: this.siparisBulOrderNumber,
      };
      soap.createClient(url, function (err, client) {
        client.iadeListele(args, function (err, result) {
          if (result.iadeListeleResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          } else {
            vm.veriler = JSON.parse(result.iadeListeleResult);
            vm.listSiparis = vm.veriler;
            vm.popupActiveSiparis = true;
          }
        });
      });
    },
    siparisSec() {
      var vm = this;

      const soap = require("soap");
      const url = state.sistemAddress;
      // alert(this.pazaryeriVal)
      const args = {
        pazaryeri: "Trendyol",
        token: Store.state.tokenId,
        sayfa: 0,
        orderNumber: "",
      };
      soap.createClient(url, function (err, client) {
        client.iadeListele(args, function (err, result) {
          if (result.iadeListeleResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          } else {
            vm.veriler = JSON.parse(result.iadeListeleResult);
            vm.listSiparis = vm.veriler;
            vm.popupActiveSiparis = true;
          }
        });
      });
    },
    barkodOku() {
      // alert(gelenorder)
      this.Bvalidated = 0;
      const vm = this;
      const vs = this.$vs;

      if (vm.barkodAdet == "") {
        vm.barkodAdet = 1;
      }
      if (vm.barkodAdet == "") {
        vs.notify({
          title: "Adet Giriniz",
          text: "Lütfen Stok Adet Giriniz",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "success",
          position: "top-center",
        });
      } else {
        vm.sipariseGoreUrunListesi = "";
        const soap = require("soap");
        const url = state.sistemAddress;
        //console.log(this.pazaryeriVal.trim()+"**"+this.partiVal+"**"+vm.barkod+"**"+this.aski+"**"+gelenorder+"**"+Store.state.tokenId)
        //  alert(vm.barkod)

        const args = {
          stokKodu: vm.barkod,
          adet: this.barkodAdet,
          depoKodu: this.selectedDepo,
          islemTipi: 1,
          kullaniciId: Store.state.UserId,
        };
        console.log(args)
        soap.createClient(url, function (err, client) {
          client.depoSayimEkle(args, function (err, result) {
            console.log(result)
            vm.veriler = JSON.parse(result.depoSayimEkleResult);
             console.log(vm.veriler)

            vm.sipariseGoreUrunListesi = vm.veriler;
            //document.getElementById("barkodM").value="";
            vm.barkod = "";
            vm.barkodAdet = "";
            vm.Bvalidated = 1;

            vm.focuslan();
          });
        });
      }

      //alert(this.barkod)
    },
    focuslan() {
      //alert("ss")
      // if (this.sipariseGoreUrunListesi!=)
      this.Bvalidated = 1;
      document.getElementById("barkodM").focus();
    },
    listeTemizle() {
      this.sipariseGoreUrunListesi = [];
      this.validated = 1;
      this.eklenenToplamParca = 0;
    },
  },
  beforeMount() {
    this.depoListeleme();
    //  console.log(Store.state.UserId)
    //setInterval(this.stokGuncelle,900000);
  },
  watch: {
    Bvalidated: function () {
      var self = this;
      if (self.Bvalidated == 1) {
        setTimeout(() => document.getElementById("barkodM").focus(), 500);
        // self.$refs.barkod.focus()
        // alert("sss")
        //document.getElementById("barkodM").focus()
        // self.$nextTick(() => self.barkod.focus())
        //self.$$.barkod.focus();
        //this.$refs["barkod"].focus()
      }
    },
  },
};
</script>

<style lang="scss">
.con-vs-dialog {
  z-index: 520055;
}
.v-select .vs__selected {
  font-size: 10px;
}
.mb-base {
  margin-bottom: 0.75rem !important;
}
.list-view-item {
  .item-name,
  .item-description {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .item-name {
    -webkit-line-clamp: 2;
  }

  .item-description {
    -webkit-line-clamp: 5;
  }

  .grid-view-img {
    max-width: 100%;
    max-height: 100%;
    width: auto;
    transition: 0.35s;
  }

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.25);

    .grid-view-img {
      opacity: 0.9;
    }
  }
}
</style>
